export const initialTimelineTypesState = {
  imagery: false,
  operational: false,
  objects: false,
};

export const initialImageryTimelineState = {
  startDate: null,
  endDate: null,
  enableFilter: false,
};
